import { AlertTriangle, Loader2, SearchX } from "lucide-react";

export const Loading = ({ label = "Yükleniyor…" }) => (
  <div data-testid="state-loading" className="flex items-center gap-3 py-16 justify-center text-zinc-500">
    <Loader2 className="h-5 w-5 animate-spin text-[#0071e3]" /> <span className="text-sm">{label}</span>
  </div>
);

export const Empty = ({ title = "Sonuç bulunamadı", hint, children }) => (
  <div data-testid="state-empty" className="panel py-14 px-6 text-center">
    <SearchX className="h-8 w-8 mx-auto text-zinc-500" />
    <p className="mt-3 font-display text-lg">{title}</p>
    {hint && <p className="mt-1 text-sm text-zinc-500">{hint}</p>}
    {children && <div className="mt-5">{children}</div>}
  </div>
);

export const ErrorBox = ({ message = "Veriler yüklenemedi" }) => (
  <div data-testid="state-error" className="rounded-md border border-red-500/40 bg-red-500/10 p-4 text-sm text-red-700 flex gap-2">
    <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" /> {message}
  </div>
);

export const FieldError = ({ children, testId }) =>
  children ? <p data-testid={testId} className="text-xs text-red-400 mt-1">{children}</p> : null;
